<template src="./index.html">
</template>
<script>
import {getdata} from "./data.js"
import {queryExportBusinessSituation, saveExportBusinessSituation} from "../../../../api/ckywqk"

export default {
  props: {
    exportBusinessSituationDiag: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    },
    suosq: {
      type: String,
      default: ""
    },
  },
  components: {
  },
  data: function () {
    return {
      headData: getdata().headData,
      tableData: getdata().tableData,
    }
  },
  watch: {
    exportBusinessSituationDiag: function (indexVal, oldVal) {
      if (indexVal) {
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate()
          }
          if (this.$refs.taxform) {
            this.$refs.taxform.clearValidate()
          }
        })
      }
    },
  },
  created() {
    if (this.params.sbbm === "zzs" && this.suosq) {
      let params = {
        shuibId: this.params.shuibId,
        companyId: this.params.companyId,
        year: this.suosq.substring(0, 4),
        suosq: this.suosq
      };
      queryExportBusinessSituation(params).then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  },
  mounted() {
  },
  methods: {
    closediag(e) {
      this.$emit("closediag", '')
    },
    confirm() {
      let params = {
        shuibId: this.params.shuibId,
        companyId: this.params.companyId,
        year: this.suosq.substring(0, 4),
        detailDtos: this.tableData
      };
      saveExportBusinessSituation(params).then((res) => {
        if (res.data.code === 1) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
      this.$emit("confirm", '')
    }
  }
};
</script>


<style scoped lang="less">
@import url("./index.less");
</style>
